module.exports = __webpack_public_path__ + "static/media/zahlavi.df30f366.webp";